import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBook, faCoins, faHandPaper } from "@fortawesome/free-solid-svg-icons";

import { useLanguage } from "../../../context/LanguageProvider";
import { ROUTES } from "../../../shared/constants/routes";
import ButtonLink from "../../../shared/components/elements/ButtonLink";
import ProgressBar from "../../../shared/components/elements/ProgressBar";

import { ACCOUNT_MESSAGES } from "../messages";
import type { MyCourse } from "../types";

interface MyCourseCardProps {
    course: MyCourse;
}

const MyCourseCard = ({ course }: MyCourseCardProps) => {
    const { lang } = useLanguage();

    return (
        <div className="w-full border-4 border-gray-200 rounded-md p-5">
            <h2 className="text-xl font-bold mb-5 text-gray-700">{course.title}</h2>

            <ProgressBar value={course.course_level} max={course.total_levels} />

            <div className="flex mt-5 flex-1 justify-between items-center gap-x-3">
                <div className="w-1/2">
                    <ButtonLink
                        to={ROUTES.myCourseContent(lang, course.course_id)}
                        className="gap-x-2 w-full"
                    >
                        <FontAwesomeIcon icon={faBook} size="lg" />
                        <span className="font-bold">{ACCOUNT_MESSAGES.lessons}</span>
                    </ButtonLink>
                </div>

                <div className="w-1/2">
                    {/* Owners get the cheatsheet, everyone else gets the purchase page */}
                    {course.has_bought ? (
                        <ButtonLink
                            to={ROUTES.myCourseCheatsheet(lang, course.course_id)}
                            className="gap-x-2 w-full"
                        >
                            <FontAwesomeIcon icon={faHandPaper} size="lg" />
                            <span className="font-bold">{ACCOUNT_MESSAGES.cheatsheet}</span>
                        </ButtonLink>
                    ) : (
                        <ButtonLink
                            to={ROUTES.purchaseCourse(lang, course.course_id)}
                            className="gap-x-2 w-full"
                        >
                            <FontAwesomeIcon icon={faCoins} size="lg" />
                            <span className="font-bold">{ACCOUNT_MESSAGES.buyCourse}</span>
                        </ButtonLink>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MyCourseCard;